import callAppFunction from './bridge';

export const getUa = (ctx?) => {
  const ua =
    typeof window === 'undefined'
      ? ctx?.req?.headers?.['user-agent']?.toLowerCase()
      : window?.navigator?.userAgent?.toLowerCase();
  return ua || '';
};

/**
 * 判断是否app打开
 */
export const isSayWeeeApp = function (ctx?) {
  const ua = getUa(ctx);
  if (ua) {
    return ua.indexOf('weeeapp') > -1 || ua.indexOf('masgustoapp') > -1;
  } else {
    return false;
  }
};

/**
 * 获取操作系统版本号
 */
export const getSystemVersion: () => Promise<{
  systemVersion: string;
  appVersion: string;
}> = () => {
  return new Promise((resolve, reject) => {
    callAppFunction('getSystemVersion', null, data => {
      resolve(data?.object);
    });
  });
};
